export default __webpack_public_path__ + "static/media/internal-portal.e2c642e9.svg";